import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function ChevronUp($$anchor, $$props) {
	const iconNode = [["path", { "d": "m18 15-6-6-6 6" }]];
	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiQ2hldnJvblVwLnN2ZWx0ZSJdLCJzb3VyY2VzQ29udGVudCI6WyI8c2NyaXB0IGxhbmc9XCJ0c1wiPlxuICBpbXBvcnQgSWNvbiBmcm9tICcuL0ljb24uc3ZlbHRlJztcbiAgY29uc3QgaWNvbk5vZGU6IFtzdHJpbmcsIFJlY29yZDxzdHJpbmcsIHN0cmluZz5dW10gPSBbW1wicGF0aFwiLCB7IFwiZFwiOiBcIm0xOCAxNS02LTYtNiA2XCIgfV1dO1xuICBsZXQgcmVzdCA9ICRwcm9wcygpO1xuPC9zY3JpcHQ+XG48SWNvbiB7aWNvbk5vZGV9IHsuLi5yZXN0fSAvPlxuIl0sIm1hcHBpbmdzIjoiOztPQUNTLElBQUksTUFBTSxlQUFlOztxREFEbEMsQ0FBQztPQUVPLFFBQTRDLEtBQUssTUFBTSxJQUFJLEdBQUcsRUFBRSxnQkFBZ0I7S0FDbEYsSUFBSTs7Ozs7Ozs7UUFFVyxJQUFJOztBQUQxQixDQUFDIn0=